import { ArrowRight } from "lucide-react";
import { mediaUrl } from "../../lib/media";
import { BannerLink } from "./BannerLink";

function SmallBanner({ b, idx }) {
  if (!b || (!b.gambar && !b.judul && !b.subjudul)) return null;
  return (
    <BannerLink
      href={b.link}
      className="hsv5-on-dark relative block overflow-hidden h-[170px] md:h-[180px] bg-[#1D1D1F] rounded-[2px] group"
      tid={`small-banner-${idx}`}
    >
      {b.gambar && (
        <>
          <img src={mediaUrl(b.gambar)} alt="" width="640" height="180" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
          <span className="absolute inset-0 bg-black/45" />
        </>
      )}
      <div className="relative h-full flex flex-col justify-end p-[22px] md:p-6">
        {b.judul && <div className="text-[22px] font-medium text-white tracking-[-0.02em] leading-tight">{b.judul}</div>}
        {b.subjudul && <div className="mt-1 text-sm text-[#E5E5EA]">{b.subjudul}</div>}
        {b.teks_tombol && (
          <span className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-[#FF6B1A]">
            {b.teks_tombol} <ArrowRight size={14} strokeWidth={1.8} />
          </span>
        )}
      </div>
    </BannerLink>
  );
}

export function SmallBanners({ list }) {
  const items = (list || []).slice(0, 2);
  if (!items.some((b) => b && (b.gambar || b.judul || b.subjudul))) return null;
  return (
    <section className="px-4 py-6 md:px-20" data-testid="small-banners">
      <div className="mx-auto w-full max-w-[1280px] grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6">
        {items.map((b, i) => <SmallBanner key={i} b={b} idx={i} />)}
      </div>
    </section>
  );
}
